import { render, staticRenderFns } from "./SelectorMocktestSegments.vue?vue&type=template&id=e8db3c38&"
import script from "./SelectorMocktestSegments.vue?vue&type=script&lang=js&"
export * from "./SelectorMocktestSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports